
import { Prop } from 'vue-property-decorator';

import { Options, Vue } from 'vue-class-component';
import Filtro from '@/model/filtros/Filtro';

@Options({
  components: {},
  name: 'BusquedaConFiltros',
})
export default class BusquedaConFiltros extends Vue {
  @Prop({ require: true })
  private filtro!: Filtro;
  @Prop({ require: true })
  private totalItems!: number;
  @Prop({ type: Boolean, default: false })
  private tieneDescarga!: boolean;

  @Prop({ type: String, default: 'Búsqueda' })
  private titulo!: string;

  @Prop({ type: Boolean, default: true })
  private showBusqueda!: boolean;

  @Prop()
  private page!: any;

  @Prop({ type: Boolean, default: false })
  private loading = false;

  declare $refs: {
    buscar: Vue & { $el: HTMLElement };
    descargar: Vue & { $el: HTMLElement };
  };
  mounted() {
    this.$nextTick(() => this.$refs.buscar.$el.focus());
  }
  buscar(val: any) {
    this.$emit('buscar', val);
  }
  descargar(val: any) {
    this.$emit('descargar', val);
  }

  limpiar() {
    this.$emit('limpiar');
  }
}
